import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, V2MailIcon } from '@paypalcorp/pp-react';

function SocialShareEmail({ url, handleAnalytics, linkTitle }) {
  const mailToHandle = () => {
    handleAnalytics('email-share');
    window.location.href = url;
  };

  return (
    <IconButton
      onClick={mailToHandle}
      data-testid="social-share-email"
      size="sm"
      buttonType="secondary"
      svgIconComponent={V2MailIcon}
    >
      {linkTitle}
    </IconButton>
  );
}

SocialShareEmail.propTypes = {
  url: PropTypes.string,
  handleAnalytics: PropTypes.func,
  linkTitle: PropTypes.string,
};

export default SocialShareEmail;
